/**
 * MENU-CONV-01 — hybrid desktop nav: primary links + drawer trigger opens conversion menu.
 */

let desktopDrawerTriggerBound = false;

function syncHybridHeaderMenuStyle() {
  const header = document.querySelector('#header-component.header-nav--hybrid');
  if (!header) return;

  if (window.matchMedia('(min-width: 750px)').matches) {
    header.dataset.menuStyle = 'menu';
  }
}

function openHeaderDrawerFromDesktop() {
  const drawer = document.querySelector('header-drawer');
  const summary = drawer?.querySelector('#Details-menu-drawer-container > summary');

  if (summary instanceof HTMLElement) {
    summary.click();
    return true;
  }

  if (drawer && typeof drawer.toggle === 'function') {
    drawer.toggle();
    return true;
  }

  return false;
}

function openHeaderDrawerFromDesktopWithRetry(attempt = 0) {
  if (openHeaderDrawerFromDesktop()) return;

  if (attempt >= 12) return;

  window.setTimeout(() => {
    openHeaderDrawerFromDesktopWithRetry(attempt + 1);
  }, 50);
}

function syncDesktopDrawerTriggerExpanded(trigger, details) {
  if (!(trigger instanceof HTMLButtonElement) || !(details instanceof HTMLDetailsElement)) return;

  const isOpen = details.classList.contains('menu-open') || details.hasAttribute('open');
  trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

function observeDesktopDrawerExpandedState() {
  const trigger = document.querySelector('[data-menu-desktop-drawer-trigger]');
  const drawer = document.querySelector('header-drawer');
  const details = drawer?.querySelector('#Details-menu-drawer-container');

  if (!(trigger instanceof HTMLButtonElement) || !(details instanceof HTMLDetailsElement)) return;

  syncDesktopDrawerTriggerExpanded(trigger, details);

  new MutationObserver(() => {
    syncDesktopDrawerTriggerExpanded(trigger, details);
  }).observe(details, {
    attributes: true,
    attributeFilter: ['open', 'class'],
  });
}

function bindDesktopDrawerTrigger() {
  if (desktopDrawerTriggerBound) return;
  desktopDrawerTriggerBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const trigger = target?.closest('[data-menu-desktop-drawer-trigger]');

      if (!(trigger instanceof HTMLButtonElement)) return;
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      event.preventDefault();
      openHeaderDrawerFromDesktopWithRetry();
    },
    { capture: true }
  );
}

function initHybridDesktopNav() {
  syncHybridHeaderMenuStyle();
  bindDesktopDrawerTrigger();
  customElements.whenDefined('header-drawer').then(observeDesktopDrawerExpandedState);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHybridDesktopNav);
} else {
  initHybridDesktopNav();
}

window.addEventListener('resize', syncHybridHeaderMenuStyle, { passive: true });
document.addEventListener('shopify:section:load', initHybridDesktopNav);
